"use client"

import moment from "moment"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { RxCross2 } from "react-icons/rx"
import { useDispatch, useSelector } from "react-redux"
import {
  fetchChecklistDetails,
  selectCurrentChecklist,
  clearCurrentChecklist,
} from "../../../redux/features/clientChecklistSlice"
import {
  fetchBankDetailsByCountry,
  selectCurrentBankDetails,
  selectIsLoading as selectBankDetailsLoading,
} from "../../../redux/features/clientBankDetail"

export default function InvoiceTab({ propsData, setActiveTab }) {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const checklist = useSelector(selectCurrentChecklist)
  const bankDetails = useSelector(selectCurrentBankDetails)
  const isBankDetailsLoading = useSelector(selectBankDetailsLoading)
console.log("Checklist in InvoiceTab:", checklist)
  const [formData, setFormData] = useState({
    clientName: propsData?.firstName + " " + propsData?.lastName,
    applicationNo: propsData.uniqueId,
    amount: checklist?.fees,
    transactionDate: "",
    transactionId: "",
    proofOfPayment: null,
    proofPreview: "",
    payStatus: "Not Paid",
    fileName: "",
  })

  useEffect(() => {
    dispatch(clearCurrentChecklist())
  }, [dispatch])

  useEffect(() => {
    if (propsData.countryOfInterest && propsData.visaCategory) {
      dispatch(
        fetchChecklistDetails({
          country: propsData.countryOfInterest,
          visaCategory: propsData.visaCategory,
        }),
      )

      dispatch(fetchBankDetailsByCountry(propsData.countryOfInterest))
    }
  }, [propsData.countryOfInterest, propsData.visaCategory, dispatch])

  // Update form data when invoice data is available
  useEffect(() => {
    if (propsData.invoice) {
      setFormData((prev) => ({
        ...prev,
        transactionDate: propsData.invoice.transactionDate,
        transactionId: propsData.invoice.transactionId,
        amount: propsData.invoice.amount || prev.amount,
        fileName: propsData.invoice.uploadedFiles?.name || "",
        payStatus: propsData.paymentStatus || "Not Paid",
      }))
    }
  }, [propsData.invoice, propsData.paymentStatus])

  const handleFileUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      setFormData((prev) => ({
        ...prev,
        proofOfPayment: file,
        proofPreview: URL.createObjectURL(file),
      }))
    }
  }

  const clearFile = () => {
    setFormData((prev) => ({
      ...prev,
      proofOfPayment: null,
      proofPreview: "",
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (bankDetails) {
      console.log(propsData.countryOfInterest)

      const formattedDate = formData.transactionDate
        ? moment(formData.transactionDate).format("YYYY-MM-DD")
        : ""

      navigate("/client/applications/form/payment", {
        state: {
          bankDetails,
          paymentInfo: { ...formData, transactionDate: formattedDate },
          countryOfInterest: propsData.countryOfInterest,
          applicationId: propsData._id,
          name: propsData.firstName + " " + propsData.lastName,
          applicationNo: propsData.uniqueId,
          amount: formData.amount,
        },
      })
    }
  }

  useEffect(() => {
    if (checklist?.fee !== undefined && checklist?.fee !== null) {
      setFormData((prev) => ({ ...prev, amount: checklist.fee }))
    }
  }, [checklist])

  const isPayNowDisabled = !bankDetails || isBankDetailsLoading

  // Format transaction date for display
  const formattedTransactionDate = formData.transactionDate ? moment(formData.transactionDate).format("YYYY-MM-DD") : ""

  return (
    <div
      onClick={() => console.log(propsData)}
      className="bg-[#FFFBF5] border border-[#CAC3BB] p-4 md:p-6 rounded-lg rounded-tl-none text-sm md:text-base"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
          {/* Left Column */}
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-900">Client Name</label>
              <input
                type="text"
                value={formData.clientName}
                readOnly
                className="w-full p-2.5 bg-gray-100 border border-gray-200 rounded-md text-gray-600"
              />
            </div>

            <div className="space-y-2">
              <label className="block font-medium text-gray-900">Application No.</label>
              <input
                type="text"
                value={formData.applicationNo}
                readOnly
                className="w-full p-2.5 bg-gray-100 border border-gray-200 rounded-md text-gray-600"
              />
            </div>

            <div className="space-y-2">
              <label className="block font-medium text-gray-900">Amount</label>
              <input
                type="number"
                value={formData.amount}
                readOnly
                placeholder="Enter amount"
                className="w-full p-2.5 bg-gray-100 border border-gray-200 rounded-md text-gray-600"
              />
            </div>

            <div className="space-y-2">
              <label className="block font-medium text-gray-900">Transaction Date</label>
              <input
                type="date"
                value={formattedTransactionDate}
                readOnly
                className="w-full p-2.5 bg-gray-100 border border-gray-200 rounded-md text-gray-600"
              />
            </div>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <label className="block font-medium text-gray-900">
                Transaction ID
                {/* {!formData.transactionId && <span className="text-red-500 text-sm ml-2">(Missing)</span>} */}
              </label>
              <input
                type="text"
                value={formData.transactionId}
                readOnly
                className={`w-full p-2.5 bg-gray-100 border border-gray-200 rounded-md text-gray-600 ${!formData.transactionId ? "border-red-300" : ""
                  }`}
                placeholder={!formData.transactionId ? "No transaction ID provided" : ""}
              />
              {!formData.transactionId && <p className="text-red-500 text-xs">Transaction ID will show after payment.</p>}
            </div>

            <div className="space-y-2">
            { propsData?.invoice?.paymentMethod !== "creditCard" &&  <label className="block font-medium text-gray-900">
                Proof of Payment
                {/* {!propsData.invoice?.uploadedFiles && !formData.fileName && (
                  <span className="text-red-500 text-sm ml-2">(Missing)</span>
                )} */}
              </label>}
              {propsData.invoice && propsData.invoice.uploadedFiles ? (
                <div className="mt-2 p-2.5 bg-gray-100 border border-gray-200 rounded-md flex justify-between items-center">
                  <p className="text-gray-600 truncate">{formData.fileName}</p>
                  <button
                    type="button"
                    onClick={() => window.open(propsData.invoice.uploadedFiles.location, '_blank')}
                    className="bg-[#005787] text-white px-3 py-1.5 rounded-full text-xs hover:bg-[#004a70] transition-colors"
                  >
                    View
                  </button>
                </div>
              ) : (
                <>
                 {propsData?.invoice?.paymentMethod !== "creditCard" && <div onClick={()=>console.log(propsData.invoice)} className="p-2.5 bg-gray-100 border border-red-300 rounded-md">
                    <p className="text-red-500 text-sm">No proof of payment uploaded</p>
                  </div>}
                  {/* <div className="flex items-center space-x-4 pt-5 justify-end">
                    <input
                      id="file-upload"
                      type="file"
                      onChange={handleFileUpload}
                      className="hidden"
                      accept="image/*,.pdf"
                    />
                  </div>

                  {formData.proofPreview && (
                    <div className="relative mt-3">
                      <img
                        src={formData.proofPreview || "/placeholder.svg"}
                        alt="Proof Preview"
                        className="w-32 h-32 object-cover border border-gray-300 rounded-md"
                      />
                      <button
                        onClick={clearFile}
                        type="button"
                        className="relative -top-36 -right-28 bg-red-500 text-white rounded-full p-1"
                      >
                        <RxCross2 />
                      </button>
                    </div>
                  )} */}
                </>
              )}
           
            </div>

            <div className="space-y-2">
              <label className="block font-medium text-gray-900">Payment Status</label>
              <input
                type="text"
                value={formData.payStatus}
                readOnly
                className="w-full p-2.5 bg-gray-100 border border-gray-200 rounded-md text-gray-600"
              />
            </div>
          </div>
        </div>

        {/* Bank details status message */}
        {isBankDetailsLoading && <div className="text-blue-600 text-sm mt-2">Loading bank details for payment...</div>}

        {!isBankDetailsLoading && !bankDetails && (
          <div className="text-red-600 text-sm mt-2">
            Bank details not available for {propsData.countryOfInterest}. Payment cannot be processed.
          </div>
        )}

        <div className="flex justify-end gap-4 mt-8">
          {propsData?.status !== "Withdrawn" &&
            propsData?.status !== "Cancelled" &&
            propsData?.status !== "WithdrawnByClient" &&
            propsData?.status !== "WithdrawnByAgent" &&
            propsData?.paymentStatus !== "Pending" &&
            propsData?.paymentStatus !== "Paid" && (
              <button
                type="submit"
                disabled={isPayNowDisabled}
                className={`px-4 py-2 rounded-full ${isPayNowDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-[#005787] hover:bg-[#004a70]"
                  } text-white`}
              >
                {isBankDetailsLoading ? "Loading..." : "Pay Now"}
              </button>
            )}
          {propsData?.invoice && propsData?.invoice?.uploadedFiles &&
            propsData?.paymentStatus !== "Paid" &&
            propsData?.paymentStatus !== "Not Paid" && (
              <button
                type="submit"
                disabled={isPayNowDisabled}
                className={`px-4 py-2 rounded-full ${isPayNowDisabled ? "bg-gray-400 cursor-not-allowed" : "bg-[#005787] hover:bg-[#004a70]"
                  } text-white`}
              >
                {isBankDetailsLoading ? "Loading..." : "Update"}
              </button>
            )}
        </div>
      </form>
    </div>
  )
}
